// src/pages/Contact.js
import React from 'react';
import { Box, Container, Typography, Grid, Paper, Link as MuiLink } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const infoCards = [
  {
    icon: <LocationOnIcon sx={{ fontSize: 36, color: '#f08a0c' }} />,
    title: 'Adres',
    lines: ['Merkez Sanayi Sitesi', '1344. Cadde 19/A', 'Yenimahalle / ANKARA'],
  },
  {
    icon: <PhoneIcon sx={{ fontSize: 36, color: '#f08a0c' }} />,
    title: 'Telefon',
    lines: [{ text: '0312 395 22 25', href: 'tel:03123952225' }],
  },
  {
    icon: <AccessTimeIcon sx={{ fontSize: 36, color: '#f08a0c' }} />,
    title: 'Çalışma Saatleri',
    lines: ['Pazartesi – Cumartesi: 08:30 – 18:00', 'Pazar: Kapalı'],
  },
];

const Contact = () => {
  return (
    <Box>
      {/* Başlık */}
      <Box
        sx={{
          backgroundColor: '#1e2128',
          py: 6,
          textAlign: 'center',
          color: 'white',
        }}
      >
        <Typography variant="overline" sx={{ color: '#f08a0c', fontWeight: 700, letterSpacing: 2 }}>
          BIZE ULAŞIN
        </Typography>
        <Typography variant="h3" fontWeight={800} sx={{ mt: 0.5 }}>
          İletişim
        </Typography>
        <Typography variant="body1" sx={{ color: '#aaa', mt: 1 }}>
          Sorularınız ve talepleriniz için bize ulaşabilirsiniz.
        </Typography>
      </Box>

      <Container maxWidth="lg" sx={{ py: 6 }}>
        {/* Bilgi Kartları */}
        <Grid container spacing={3} sx={{ mb: 5 }} justifyContent="center">
          {infoCards.map((card, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  textAlign: 'center',
                  border: '1px solid #f0f0f0',
                  borderRadius: 3,
                  height: '100%',
                  transition: 'border-color 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    borderColor: '#f08a0c',
                    boxShadow: '0 4px 20px rgba(240,138,12,0.12)',
                  },
                }}
              >
                <Box sx={{ mb: 2 }}>{card.icon}</Box>
                <Typography variant="h6" fontWeight={700} gutterBottom>
                  {card.title}
                </Typography>
                {card.lines.map((line, j) => {
                  const item = typeof line === 'string' ? { text: line } : line;
                  return item.href ? (
                    <MuiLink key={j} href={item.href} underline="hover" sx={{ display: 'block', color: '#f08a0c', fontWeight: 600, fontSize: '1rem', lineHeight: 2 }}>
                      {item.text}
                    </MuiLink>
                  ) : (
                    <Typography key={j} variant="body2" color="text.secondary" sx={{ lineHeight: 2 }}>
                      {item.text}
                    </Typography>
                  );
                })}
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Google Maps */}
        <Box
          sx={{
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            border: '1px solid #eee',
          }}
        >
          <iframe
            title="İrem Otomotiv Konum"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3056.64943238932!2d32.76061487546111!3d39.99393898126426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d34a2cd17a4b29%3A0xc74b163341700c31!2s%C4%B0rem%20Otomotiv!5e0!3m2!1str!2str!4v1774116968820!5m2!1str!2str"
            width="100%"
            height="450"
            style={{ border: 0, display: 'block' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </Box>
      </Container>
    </Box>
  );
};

export default Contact;
